// components/partnerOnboarding/PromotionLinks.js
import React from 'react';
import ReferralLink from '../../components/referralLink'; 

function PromotionLinks() {
  return (
    <div>
      <h3 className="mb-4">Promotion Links</h3>
       <div className='mb-4'>
        <ReferralLink/>
        </div> 
      <div className="mb-4">
        <h5>Promotion Strategies</h5>
        <p>Watch this quick video to learn effective promotion techniques:</p>
        <div className="ratio ratio-16x9">
          <iframe src="https://www.youtube.com/embed/dQw4w9WgXcQ" title="Promotion Strategies" allowFullScreen></iframe>
        </div>
      </div>
    </div>
  );
}

export default PromotionLinks;